module.exports = __webpack_public_path__ + "static/media/img_dance07.526bb906.png";